import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-termo-uso',
    templateUrl: './termo-uso.component.html',
    styleUrls: ['./termo-uso.component.sass']
})
export class TermoUsoComponent implements OnInit {
    modal = '';
    href =  '/politica-privacidade';
    termoDeUsoAceito: boolean;
    @Input() type: string;
    @Input() link: string;
    @Output() termoDeUsoAceitoEmit = new EventEmitter();

    constructor() {}

    async ngOnInit() {
        if (this.link) {
            this.href = this.link;
        }
    }

    insideLinkText() {
        switch (this.type) {
            case 'pagamento':
                return 'Regulamento';
            case 'indique-e-ganhe':
                return 'regulamento de indicação';
            case 'faca-parte':
            default:
                return 'Política de Privacidade';
        }
    }

    termoDeUsoAlterado() {
        this.termoDeUsoAceitoEmit.emit(this.termoDeUsoAceito);
    }
}
